import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios, blobToBase64 } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  params: {
    year: new Date().getFullYear(),
    month: '0',
    type: 'all',
  },
};

const slice = createSlice({
  name: 'trialBalance',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET REPORT
    getReportSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams } = slice.actions;

// ----------------------------------------------------------------------

export function getReport(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/accounting-reports/trial_balance/', { params });
      dispatch(slice.actions.getReportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function printTrialBalance(params = {}) {
  return async () => {
    // dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/accounting-reports/trial-balance-print/', { params, responseType: 'blob' });
      if (window.isNativeApp) return await blobToBase64(response.data);
      try {
        return URL.createObjectURL(response.data);
      } catch (err) {
        console.error('Failed to create object URL:', err);
        throw err;
      }
    } catch (error) {
      console.error(error);
      return error;
    }
  };
}
